import { render, staticRenderFns } from "./DetailPlanCard.vue?vue&type=template&id=610dcdfc&scoped=true&"
import script from "./DetailPlanCard.vue?vue&type=script&lang=ts&"
export * from "./DetailPlanCard.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPlanCard.vue?vue&type=style&index=0&id=610dcdfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610dcdfc",
  null
  
)

export default component.exports